import { useTranslation } from 'react-i18next'
import DesignerNodeCard from './DesignerNodeCard'

export default function CapabilitiesSectionV2() {
  const { t } = useTranslation('landing')
  return (
    <section className="bg-black px-4 py-[60px] sm:px-6 md:px-20">
      <div className="mx-auto flex max-w-[1280px] flex-col gap-[60px]">
        {/* Header */}
        <div className="flex flex-col gap-4">
          <h2 className="max-w-[640px] font-[Fustat] text-hero font-medium leading-[1.1] text-white md:text-display-md">
            {t('capabilitiesV2.heading')}
          </h2>
          <p className="max-w-[784px] font-[Fustat] text-base leading-[1.6] text-[#a1a1aa] md:text-xl md:font-medium">
            {t('capabilitiesV2.subtitle')}
          </p>
        </div>

        {/* Feature cards */}
        <div className="flex flex-col gap-6">
          {/* Top row: Characters + Location */}
          <div className="flex flex-col gap-6 lg:flex-row">
            {/* Characters card */}
            <div className="relative min-h-[520px] w-full shrink-0 overflow-hidden rounded-[28px] border border-white/[0.08] bg-gradient-to-b from-[#2e3861] via-[#14141f] to-[#0a0a12] md:h-[640px] md:rounded-[32px] lg:w-[628px]">
              {/* Background image */}
              <div className="absolute inset-0 overflow-hidden">
                <img
                  src="/landing-v2/characters-bg.jpg"
                  alt=""
                  className="absolute left-[-164%] top-0 h-full w-[264%] object-cover"
                />
              </div>

              {/* Designer node replica (coded, not a screenshot) */}
              <div className="absolute inset-0 flex items-center justify-center pb-[120px]">
                <div className="scale-[0.82] sm:scale-[0.92]">
                  <DesignerNodeCard
                    accent="#EAB308"
                    typeLabel={t('capabilitiesV2.characters.typeLabel')}
                    title={t('capabilitiesV2.characters.title')}
                    role={t('capabilitiesV2.characters.role')}
                    description={t('capabilitiesV2.characters.description')}
                    imageSrc="/landing-v2/char-render.jpg"
                    aspect="aspect-video"
                  />
                </div>
              </div>

              {/* Text overlay */}
              <div className="absolute bottom-0 left-0 right-0 flex flex-col gap-3 p-6 text-white md:p-10">
                <h3 className="font-[Fustat] font-semibold text-xl">{t('capabilitiesV2.characters.heading')}</h3>
                <p className="font-[Fustat] text-base leading-[1.6]">
                  {t('capabilitiesV2.characters.body')}
                </p>
              </div>
            </div>

            {/* Location card */}
            <div className="relative min-h-[520px] flex-1 overflow-hidden rounded-[28px] border border-white/[0.08] bg-gradient-to-b from-[#2e3861] via-[#14141f] to-[#0a0a12] md:h-[640px] md:rounded-[32px]">
              {/* Background image */}
              <div className="absolute inset-0 overflow-hidden">
                <img
                  src="/landing-v2/location-bg.jpg"
                  alt=""
                  className="absolute left-0 top-0 h-full w-[208%] object-cover"
                />
              </div>

              {/* Designer node replica (coded, not a screenshot) */}
              <div className="absolute inset-0 flex items-center justify-center pb-[120px]">
                <div className="scale-[0.82] sm:scale-[0.92]">
                  <DesignerNodeCard
                    accent="#22C55E"
                    typeLabel={t('capabilitiesV2.location.typeLabel')}
                    title={t('capabilitiesV2.location.title')}
                    role={t('capabilitiesV2.location.role')}
                    description={t('capabilitiesV2.location.description')}
                    imageSrc="/landing-v2/loc-render.jpg"
                    aspect="aspect-video"
                  />
                </div>
              </div>

              {/* Text overlay */}
              <div className="absolute bottom-0 left-0 right-0 flex flex-col gap-3 p-6 text-white md:p-10">
                <h3 className="font-[Fustat] font-semibold text-xl">{t('capabilitiesV2.location.heading')}</h3>
                <p className="font-[Fustat] text-base leading-[1.6]">
                  {t('capabilitiesV2.location.body')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
